module.exports = __webpack_public_path__ + "assets/img/fifth-user.f86e8ab1.png";